import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import SocialAccountPropType from "../../../_types/SocialAccount";
import PostPropType from "../../../_types/Post";
import { getSocialProviderBySocialType } from "../../../_utils/socialProvider";
import SocialAccountsList from "../SocialAccountsList/SocialAccountsList";
import SocialPostCard from "../SocialPostCard/SocialPostCard";

const PostPreview = ({ accounts, postsByProvider }) => {
  const { t } = useTranslation(["planner"]);
  const [account, setAccount] = useState();
  const [post, setPost] = useState();

  const handleAccountsChange = useCallback(
    (ids) => {
      const id = ids[0];
      const selectedAccount = accounts.find((item) => item.id === id);
      const provider = getSocialProviderBySocialType(
        selectedAccount.social_type
      );

      setAccount(selectedAccount);
      setPost(postsByProvider[provider]);
    },
    [setAccount, setPost]
  );

  return (
    <Box>
      <Box display="flex" justifyContent="center" marginBottom="4">
        <SocialAccountsList
          selected={account ? [account.id] : []}
          accounts={accounts || []}
          required
          onChange={handleAccountsChange}
        />
      </Box>
      {account && post ? (
        <SocialPostCard
          account={account}
          post={post}
          marginLeft="auto"
          marginRight="auto"
        />
      ) : null}
      <Box
        padding="2"
        marginTop="2"
        textAlign="center"
        fontSize="xs"
        color="gray.300"
      >
        {t("post_preview.info")}
      </Box>
    </Box>
  );
};

PostPreview.propTypes = {
  accounts: PropTypes.arrayOf(SocialAccountPropType).isRequired,
  postsByProvider: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape(PostPropType),
  }).isRequired,
};

PostPreview.defaultProps = {};

export default PostPreview;
